import React, { useState, useEffect } from "react";
import { Button, Tab } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import {
  ListAssistance,
  AssistanceForm,
} from "../../../components/Admin/Assistance";
import "./Assistance.scss";

export function Assistance() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  useEffect(() => {
    const imageKey = `imageAvatar`;

    // Verificar si la imagen está almacenada en localStorage
    if (localStorage.getItem(imageKey)) {
      // Si está almacenada, eliminarla
      localStorage.removeItem(imageKey);
    }
  }, []);

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListAssistance reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="assistance-page">
        <div className="assistance-page__add">
          <Button primary onClick={onOpenCloseModal}>
            Nuevo Asistente
          </Button>
        </div>
        <Tab menu={{ secondary: true }} panes={panes} />
      </div>
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Crear nuevo assistance"
        size="large" //es large porque el contenido del modal es grande
      >
        <AssistanceForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  );
}
